export default __webpack_public_path__ + "static/loupe-navigation-redesign-company-context-f18cc71c58c317d8bbbb0d2bd99ac6e5.png";